import { IApplicationState, TBoardId, TColorId } from '../../../../types/types';
import { getBoardCardColorTags } from '../../selectors/getBoardCardColorTags';
import { getBoardUserMeta } from '../../boardUserMetas/selectors/getBoardUserMeta';
import { getBoardColors } from './getBoardColors';

export const getBoardUserMetaRecentColorTags = (
    state: IApplicationState,
    boardId: TBoardId,
): TColorId[] => {
    const userBoardMeta= getBoardUserMeta(state, boardId);
    const boardColorsTagIds = getBoardColors(state, boardId).map(colorTag => colorTag.id);
    return (userBoardMeta && userBoardMeta.recentColorTags || [])
        .filter(colorTagId => boardColorsTagIds.includes(colorTagId)); // проверяем, есть ли такие колортеги
};
